import React, { useEffect, useState } from "react";
import Modal from "../Modal/modal";
import "./talkToUsModal.scss";
import { getWaitText } from "../../utils/helperFunctions";

const TalkToUsModal = ({ isOpen, onClose, data }) => {
  const [
    showTalkToUsModal,
    setShowTalkToUsModal,
  ] = useState(false);
  const {
    webSubDesc,
    webDesc,
    phoneNumber,
    isAvailable,
  } = data;

  useEffect(() => {
    setShowTalkToUsModal(isOpen);
  }, [isOpen]);

  const waitText = getWaitText(data);

  return (
    <Modal
      showModal={showTalkToUsModal}
      setShowModal={setShowTalkToUsModal}
      onClose={onClose}
      title={"Talk To Us"}
    >
      <div className="talk-to-us-modal">
        <div className="tele-number-wrapper">
          <p className="tele-number">{phoneNumber}</p>
          {waitText ? (
            <p
              className={`wait-time-wrapper ${
                isAvailable ? "" : "disabled"
              }`}
            >
              {waitText}
            </p>
          ) : null}
        </div>
        {webDesc ? <p className="desc">{webDesc}</p> : null}
        {webSubDesc ? (
          <p className="desc">{webSubDesc}</p>
        ) : null}
      </div>
    </Modal>
  );
};

export default TalkToUsModal;
